import { AppService } from './../../service/app.service';
import { AuthService } from './../../service/auth.service';
import { SessionService, ISessionStoreReturnModel } from './../../service/session.service';
import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Renderer2, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarService } from './../../service/sidebar.service';
import { Title } from "@angular/platform-browser";
import { AccessibilityService } from '../../service/accessibility.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {
  model: any = null;
  currentPage: string = 'login';
  sessionTimeout: boolean;
  alreadyVoted: boolean;
  inverted: string;
  pin: string;
  showPIN: boolean = false;
  showSSN: boolean = false;

  formGroup = new FormGroup({
    ElectionId: new FormControl(),
    LoginId: new FormControl(null,
      {
        validators: [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('\\d+')],
        updateOn: 'submit'
      }),
    LoginPin: new FormControl(null,
      {
        validators: [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('\\d+')],
        updateOn: 'submit'
      })
  });

  validationMessages = {
    LoginId: {
      Required: 'Please enter the Employee ID number.',
      MinLength: 'Your Employee ID number must be at least 6 digits.',
      MaxLength: 'Your Employee ID number should only be 6 digits.',
      RegularExpression: 'Your Employee ID number must only be numbers.',
    },
    LoginPin: {
      Required: 'Please enter the assigned PIN.',
      MinLength: 'The PIN should be at least 6 digits long.',
      MaxLength: 'The PIN should be at most 6 digits long.',
      RegularExpression: 'The PIN should only be numbers.'
    }
  }

  private sessionStoreResponseModel: ISessionStoreReturnModel;
  @ViewChild('submitbtn') submitbtn: ElementRef;
  constructor(
    private http: HttpClient,
    private router: Router,
    private sidebarService: SidebarService,
    private authService: AuthService,
    private sessionService: SessionService,
    private appService: AppService,
    private titleService: Title,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private ref: ChangeDetectorRef,
    private accessService: AccessibilityService) {

    this.model = JSON.parse((<any>document.getElementById('model')).value);
    this.formGroup.patchValue(this.model);
    this.authService.setIsLoggedIn(false);
    this.titleService.setTitle("Log In - 2026 CAPE Contract Ratification");
    this.sessionTimeout = authService._sessionTimeout;
    this.alreadyVoted = authService._alreadyVoted;
  }

  ngOnInit() {
    this.clearAll();
    this.sessionService.abandonSessionState();
    this.sidebarService.showSidebar();
    this.model.LoginScreenOpenMessage = this.model.LoginScreenOpenMessage.replace(/\\"/g, '"');
    this.inverted = this.accessService.current.contrast;
  }

  ngAfterViewInit() {
    setTimeout(() => this.checkPin(), 0);
    //this.showPhoneLink();
  }

  submitted: boolean = false;
  errorMessage: string = '';

  showPhoneLink() {
    if (window.innerWidth >= 700) {
      document.getElementById('callLink').innerHTML = '(626) 243-0340';
    }
  }

  showPINCheck() {
    this.showPIN = !this.showPIN;
  }

  showSSNCheck() {
    this.showSSN = !this.showSSN;
  }

  submit() {
    this.submitbtn.nativeElement.focus();
    this.submitted = true;
    this.errorMessage = '';
    if (this.formGroup.valid) {
      this.authService.login(this.formGroup.value).subscribe(
        (response: any) => {
          if (response && response.status === 200) {
            if (this.pin != "") { document.cookie = "pin =;SameSite=Strict; secure;expires=Thu, 01 Jan 1970 00:00:01 GMT;"; }
            this.authService._sessionTimeout = false;
            setTimeout(() => this.router.navigate(['/landing']), 0);
          } else {
            const errText = (response.error as string).replace(/\s+/g, ' ');

            if (errText.includes("last 4 digits of your Social Security")) {
              console.log("HIT!");
              this.errorMessage = "Invalid login attempt. Check your PIN and Employee ID number and try again.";
            } else {
              this.errorMessage = response.error;
            }
          }
        },
        error => {
          this.errorMessage = error;
        }
      );
    } else {
      this.formGroup.get('LoginId').markAsTouched();
      this.formGroup.get('LoginPin').markAsTouched();
      return;
    }
  }

  checkPin() {
    const cookiePIN = getCookie("pin");
    if (cookiePIN != "") {
      this.pin = cookiePIN;
      this.ref.detectChanges();
      this.formGroup.get("LoginPin").patchValue(cookiePIN);
      this.renderer.selectRootElement('#LoginId').focus();
    }

    function getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }

  gotoSettings() {
    this.router.navigate(['/settings']);
  }

  keydownSettings(e) {
    e.preventDefault();

    if (e.keyCode === 32 || e.keyCode === 13) { 
      this.gotoSettings();
    }
  }

  clearAll() {
    this.appService.clearAll();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/login/login.component.ts